

const ItemCountBadge = ( {count = 0, className = ''} ) =>
    count > 0 &&
    <span className={`badge text-white ${className}`}
          data-item-count={count}
          data-testid="cart-count-badge"/>;

export default ItemCountBadge;